import { Environment } from './environment.model';

export const environment: Environment = {
  productionMode: true,
  googleTagManagerId: 'GTM-T7G2NMS2',
  prismicEndpoint: 'https://sunrise-chmobile.cdn.prismic.io/api/v2',
  brand: 'chmobile',
  // Don't need to redirect off the main domain name on production as cloudflare will handle the reverse proxying
  legacyRedirect: '',
  internalUrls: [/^(\/(en|de|fr|it))?(\/.+)?$/],
  fallbackLang: 'de',
  ratePlansPath: '/resources/rateplans.json',
  newMicroServiceEndpoint: 'https://prod.ms.api.chmobile.ch',
  checkoutUrl: 'https://checkout.chmobile.ch',
  allowedMsEnvs: [],
  defaultUrlsEnvironment: '',
  yalloFreeTvLoginUrl: 'na',
  yalloTvUrl: 'na',
  distributionIds: [],
  featureFlagClientKey: 'sdk-1AyWzT53SObto3SV',
  selfcareUrl: 'https://my.chmobile.ch',
  sprinklerAppId: '66c60bb29bfd097343b32b8c_app_444',
  firebaseConfig: {
    apiKey: 'AIzaSyAy_kRIpC77x0Gi_B0Tk-KxR-5Dovz1EvM',
    authDomain: 'kitsune-5f556.firebaseapp.com',
    projectId: 'kitsune-5f556',
    storageBucket: 'kitsune-5f556.firebasestorage.app',
    messagingSenderId: '531543266921',
    appId: '1:531543266921:web:42f7b98f137cc55293b4f8',
    measurementId: 'G-7SBX79W84Q',
  },
};
